<div class="layout-content">
	<div *ngIf="loadingEdit || buildingForm">
		<div class="flex align-items-center justify-content-center w-full pb-8 mb-8">
			<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
		</div>
	</div>
	<form *ngIf="!loadingEdit && moduleForm && !buildingForm" (ngSubmit)="submit()" [formGroup]="moduleForm">
		<!-- NOME * -->
		<div class="grid">
			<div class="col-12">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.Name, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Name, 'label')">{{ 'NAME' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Name, 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" formControlName="Name"
							autocomplete="module-name" placeholder="{{ 'NAME' | translate }}" maxlength="48" />
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.Name)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
		</div>
		<!-- FIRMWARE * -->
		<div class="grid">
			<div class="col-12 text-sm flex justify-content-start align-items-center flex-wrap">
				<div class="">{{'FWVersion' | translate }}: {{(module.FWVersion) ? (module.FWVersion) :
					('NO_TASK_INFO_AVAILABLE' | translate)}}</div>
			</div>
			<div class="col-12 pt-0 text-sm flex justify-content-start align-items-center flex-wrap">
				<div class="">{{'FWVersionBL' | translate }}: {{(module.FWVersionBL) ? (module.FWVersionBL) :
					('NO_TASK_INFO_AVAILABLE' | translate)}}</div>
			</div>
		</div>
		<!-- BUTTONS LAYOUT -->
		<div class="grid mt-3">
			<div class="col-12 flex align-items-center justify-content-center text-3xl font-medium">
				{{ getLayoutStringWithoutFinalDoublePoints() }}
			</div>
		</div>
		<div class="flex flex-row align-items-center justify-content-around w-full pb-3">
			<p-selectButton [options]="layoutList" formControlName="Layout" optionValue="value"
				(onChange)="onChangeLayout()" styleClass="p-selectbutton-round mx-2">
				<ng-template let-item pTemplate>
					<p-image src="{{item.label}}" alt="" [width]="onExtendedMobile() ? '70' : '70'" class="pt-1"></p-image>
				</ng-template>
			</p-selectButton>
		</div>
		<div class="grid mt-3">
			<div [class]="col12Responsive()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.Button1, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Button1, 'label')">{{ 'BUTTON' | translate }} 1</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Button1, 'borderInput')">
						<p-dropdown [options]="listUnit" formControlName="Button1" [ngClass]="dynamicInputTextWidth()"
							[styleClass]="dynamicInputTextWidth()" inputStyleClass="border-noround-right"
							panelStyleClass="text-center" optionLabel="Name" [filter]="true" filterBy="Name" appendTo="body">
						</p-dropdown>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.Button1)" class="flex align-items-center label-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div [class]="col12Responsive()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.Button2, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Button2, 'label')">{{ 'BUTTON' | translate }} 2</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Button2, 'borderInput')">
						<p-dropdown [options]="listUnit" formControlName="Button2" [ngClass]="dynamicInputTextWidth()"
							[styleClass]="dynamicInputTextWidth()" inputStyleClass="border-noround-right"
							panelStyleClass="text-center" optionLabel="Name" [filter]="true" filterBy="Name" appendTo="body">
						</p-dropdown>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.Button2)" class="flex align-items-center label-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
		</div>
		<!-- SETTINGS * -->
		<div class="grid mt-3">
			<div class="col-12 flex align-items-center justify-content-center text-3xl font-medium">
				{{ 'SETTINGS' | translate }}
			</div>
		</div>
		<div *ngFor="let setting of mtmacConfig; let i=index;">
			<div *ngIf="setting.Value !== null && isSettingsVisible(setting)"
				[class]="onExtendedMobile() ? 'grid mt-1' : 'col-12 flex align-items-center justify-content-between px-0 pb-0' ">
				<ng-container>
					<div *ngIf="setting.Type === 'int'"
						[class]="onExtendedMobile() ? 'col-12 flex align-items-center justify-content-center text-center' : 'col-6 pl-0 flex align-items-center justify-content-start text-start' ">
						{{ getTranslate(setting.Name, true) }}</div>
					<div *ngIf="setting.Type === 'int'" [class]="onExtendedMobile() ? 'col-12 pt-0' : 'col-6 px-0 py-1' "
						class="flex align-items-center justify-content-center">
						<div class="flex align-items-center justify-content-center w-full">
							<p-button pTooltip="{{ 'DECREASE' | translate }}" [disabled]="isSliderMin(setting)"
								tooltipPosition="bottom" icon="pi cm-minus" size="large" (click)="setSliderValue(setting, -1)"
								[rounded]="false" [text]="true" severity="primary" class="pr-3">
							</p-button>
							<div>{{formattedSliderMin(setting)}}</div>

							<div class="flex flex-column w-full mx-4">
								<!-- !! TO CHECK IF VARIANT=FILLED IS OK (punto al posto della virgola)-->
								<p-inputNumber mode="decimal" [useGrouping]="false" variant="filled"
									[formControlName]="setting.Name" class="flex w-full" styleClass="flex w-full"
									[min]="setting.Min" [max]="setting.Max" (onBlur)="onChangeInputSlider(setting)">
								</p-inputNumber>
								<p-slider [formControlName]="setting.Name" class="w-full" [step]="setting.StepSize"
									[min]="setting.Min" [max]="setting.Max" (onChange)="onChangeSlider(setting)">
								</p-slider>
							</div>

							<div>{{ formattedSliderMax(setting) }}</div>
							<p-button pTooltip="{{ 'INCREASE' | translate}}" [disabled]="isSliderMax(setting)"
								tooltipPosition="bottom" icon="pi cm-plus" size="large" (click)="setSliderValue(setting, 1)"
								[rounded]="false" [text]="true" severity="primary" class="pl-3">
							</p-button>
							<!--OLD-->
							<!--
							<p-button pTooltip="{{ 'DECREASE' | translate }}"
									[disabled]="isSliderMin(setting)"
									tooltipPosition="bottom" icon="pi cm-minus" size="large"
									(click)="setSliderDecreaseValue(setting)" [rounded]="false" [text]="true" severity="primary"
									class="pr-3">
							</p-button>
							<div>{{setting.Min}}</div>

							<div class="flex flex-column w-full mx-4">
								<p-inputNumber mode="decimal"  [useGrouping]="false"
										[formControlName]="setting.Name"
										class="flex w-full"
										styleClass="flex w-full"
										[min]="setting.Min"
										[max]="setting.Max"
										(onBlur)="onChangeInputSlider(setting)">
								</p-inputNumber>
								<p-slider [formControlName]="setting.Name" class="w-full" [step]="setting.StepSize"
										[min]="setting.Min"
										[max]="setting.Max"
										(onChange)="onChangeSlider(setting)">
								</p-slider>
							</div>
								
							<div>{{setting.Max}}</div>
							<p-button pTooltip="{{ 'INCREASE' | translate}}"
										[disabled]="isSliderMax(setting)"
										tooltipPosition="bottom" icon="pi cm-plus" size="large"
										(click)="setSliderIncreaseValue(setting)" [rounded]="false" [text]="true" severity="primary"
										class="pl-3">
							</p-button>-->
						</div>
					</div>
					<!-- !! TO CHECK LAYOUT AND FEATURE -->
					<div *ngIf="setting.Type === 'numeric'">
						<div class="flex justify-content-between flex-wrap">
							<div class="flex align-items-center justify-content-center">{{ 'DEFINE_DELAY_TIME' | translate }}
							</div>
							<div class="flex align-items-center justify-content-center">
								<p-inputNumber [formControlName]="setting.Id" step="1" [useGrouping]="false"
									[maxFractionDigits]="0" [showButtons]="true" incrementButtonClass="p-0"
									decrementButtonClass="p-0 border-noround" [max]="setting.Max" [min]="setting.Min">
								</p-inputNumber>
							</div>
						</div>
					</div>
					<!-- DROPDOWNS WITH MORE THAN TWO OPTIONS -->
					<div *ngIf="setting.Type === 'intset'" class="col-12 px-0" [class]="onExtendedMobile() ? '' : 'pb-0'">
						<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
							[ngClass]="dynamicBorderLabelMobile('borderRow')">
							<div class="flex align-items-center justify-content-center"
								[ngClass]="dynamicBorderLabelMobile('label')">{{ getTranslate(setting.Name, true) }}
							</div>
							<div class="flex align-items-end justify-content-center gap-2"
								[ngClass]="dynamicBorderLabelMobile('borderInput')">
								<p-button *ngIf="setting.Name === 'In1Func' && !this.onExtendedMobile()"
									pTooltip="{{ 'READ_INFO_FOR' | translate }} {{ 'MTMA_CONF_In1Func' | translate }}"
									tooltipPosition="bottom" (click)="infoDialogGenericEntry(setting.Name)" icon="pi cm-info" size="large"
									[rounded]="false" [text]="true" severity="primary">
								</p-button>
								<p-dropdown [options]="setting.Values" [ngClass]="dynamicInputTextWidth()" appendTo="body"
									styleClass="{{ dynamicInputTextWidth() }} align-items-center text-center"
									panelStyleClass="text-center" [formControlName]="setting.Name">
									<ng-template pTemplate="selectedItem">
										<div class="item" class="flex align-items-center justify-content-center text-center pl-5">
											<div class="flex align-items-center">{{ (f[setting.Name]) ?
												getTranslate(f[setting.Name].value.Label, false) : "" }}</div>
										</div>
									</ng-template>
									<ng-template let-controlItem pTemplate="item">
										<div class="item">
											<div>{{ getTranslate(controlItem.Label, false)}}</div>
										</div>
									</ng-template>
								</p-dropdown>
							</div>
						</div>
						<!-- NO VALIDATOR HERE -> SET DEFAULT VALUE FOR DROPDOWN AND REMOVE 'small' MESSAGE -->
						<!-- <small *ngIf="showErrorRequiredMessage(this.f.settingValue)" class="flex align-items-center label-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small> -->
					</div>
					<!-- DROPDOWNS: ENABLE / DISABLE -->
					<div *ngIf="setting.Type === 'bool'" class="col-12 px-0" [class]="onExtendedMobile() ? '' : 'pb-0'">
						<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
							[ngClass]="dynamicBorderLabelMobile('borderRow')">
							<div class="flex align-items-center justify-content-center"
								[ngClass]="dynamicBorderLabelMobile('label')">{{ getTranslate(setting.Name, true) }}</div>
							<div class="flex align-items-end justify-content-center gap-2"
								[ngClass]="dynamicBorderLabelMobile('borderInput')">
								<p-button *ngIf="setting.Name === 'DtmfTimeoutMode' && !this.onExtendedMobile()"
									pTooltip="{{ 'READ_INFO_FOR' | translate }} {{ 'MTMA_CONF_DtmfTimeoutMode' | translate }}" tooltipPosition="bottom"
									(click)="infoDialogGenericEntry(setting.Name)" icon="pi cm-info" size="large" [rounded]="false" [text]="true" severity="primary">
								</p-button>
								<p-dropdown [options]="setting.Values" (onChange)="changedBoolDropdownVoice(setting)"
									[ngClass]="dynamicInputTextWidth()" appendTo="body"
									styleClass="{{ dynamicInputTextWidth() }} align-items-center text-center"
									panelStyleClass="text-center" [formControlName]="setting.Name">
									<ng-template pTemplate="selectedItem">
										<div class="item" class="flex align-items-center justify-content-center text-center pl-5">
											<div class="flex align-items-center">{{ (f[setting.Name]) ?
												getTranslate(f[setting.Name].value.Label, false) : "" }}</div>
										</div>
									</ng-template>
									<ng-template let-controlItem pTemplate="item">
										<div class="item">
											<div>{{ getTranslate(controlItem.Label, false)}}</div>
										</div>
									</ng-template>
								</p-dropdown>
							</div>
						</div>
						<!-- NO VALIDATOR HERE -> SET DEFAULT VALUE FOR DROPDOWN AND REMOVE 'small' MESSAGE -->
						<!-- <small *ngIf="showErrorRequiredMessage(this.f.settingValue)" class="flex align-items-center label-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small> -->
					</div>
					<!-- SERVER NTP -->
					<div *ngIf="setting.Type === 'str'" class="col-12 px-0" [class]="onExtendedMobile() ? '' : 'pb-0'">
						<div class="flex justify-content-between flex-wrap"
							[ngClass]="newShowErrors(setting.Name,'borderRow')">
							<div class="flex align-items-center justify-content-center"
								[ngClass]="newShowErrors(setting.Name,'label')">{{ getTranslate(setting.Name, true) }} </div>
							<div class="flex align-items-center justify-content-center"
								[ngClass]="newShowErrors(setting.Name,'borderInput')">
								<input type="text" pInputText [ngClass]="dynamicInputTextWidth()"
									[formControlName]="setting.Name" [placeholder]="getTranslate(setting.Name, true)"
									maxlength="{{ setting.Max }}" />
							</div>
						</div>
						<small *ngIf="showErrorRequiredMessage(setting.Name)" class="flex align-items-center text-50 pt-1"
							[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
					</div>
					<!-- TIMEZONE -->
					<div *ngIf="setting.Type === 'tzlist'" class="col-12 px-0 pb-0">
						<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
							[ngClass]="dynamicBorderLabelMobile('borderRow')">
							<div class="flex align-items-center justify-content-center"
								[ngClass]="dynamicBorderLabelMobile('label')">{{ setting.Name }}</div>
							<div class="flex align-items-center justify-content-center"
								[ngClass]="dynamicBorderLabelMobile('borderInput')">
								<p-dropdown [options]="timezones" [ngClass]="dynamicInputTextWidth()" appendTo="body"
									styleClass="{{ dynamicInputTextWidth() }} align-items-center text-center"
									panelStyleClass="text-center" [formControlName]="setting.Name">
									<ng-template pTemplate="selectedItem">
										<div class="item" class="flex align-items-center justify-content-center text-center pl-5">
											<div class="flex align-items-center">{{ (f[setting.Name]) ? f[setting.Name].value : ""
												}}</div>
										</div>
									</ng-template>
									<ng-template let-controlItem pTemplate="item">
										<div class="item">
											<div>{{ controlItem }}</div>
										</div>
									</ng-template>
								</p-dropdown>
							</div>
						</div>
						<!-- NO VALIDATOR HERE -> SET DEFAULT VALUE FOR DROPDOWN AND REMOVE 'small' MESSAGE -->
						<!-- <small *ngIf="showErrorRequiredMessage(this.f.settingValue)" class="flex align-items-center label-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small> -->
					</div>
				</ng-container>
			</div>
		</div>
		<!-- ENABLE GROUPS -->
		<div class="grid mt-3">
			<div class="col-12 flex align-items-center justify-content-center text-xl font-medium">
				{{ 'MANAGE_CONTROL_ACCESS' | translate}} - {{ 'ENABLE_GROUPS' | translate }}
			</div>
		</div>
		<div class="grid mt-0">
			<div [class]="col6ResponsiveNoPadding()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.In1Rule, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.In1Rule, 'label')">{{ 'ASSOCIATE_GROUP_TO_INGRESS' | translate }} 1</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.In1Rule, 'borderInput')">
						<p-dropdown [options]="mtmaGroups" formControlName="In1Rule" [ngClass]="dynamicInputTextWidth()"
							styleClass="{{dynamicInputTextWidth()}} pl-5" inputStyleClass="border-noround-right"
							panelStyleClass="text-center" optionLabel="Name" [filter]="true" filterBy="Name" appendTo="body">
						</p-dropdown>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.In1Rule)" class="flex align-items-center label-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div [class]="col6ResponsiveNoPadding()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.In2Rule, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.In2Rule, 'label')">{{ 'ASSOCIATE_GROUP_TO_INGRESS' | translate }} 2</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.In2Rule, 'borderInput')">
						<p-dropdown [options]="mtmaGroups" formControlName="In2Rule" [ngClass]="dynamicInputTextWidth()"
							styleClass="{{dynamicInputTextWidth()}} pl-5" inputStyleClass="border-noround-right"
							panelStyleClass="text-center" optionLabel="Name" [filter]="true" filterBy="Name" appendTo="body">
						</p-dropdown>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.Button2)" class="flex align-items-center label-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
		</div>
		<!-- END * -->

		<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>